// 中英文语言支持
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)
let lang = localStorage.getItem('language') || 'zh'
if (!['zh', 'en'].includes(lang)) {
  lang = 'zh'
  localStorage.setItem('language', lang)
}
const i18n = new VueI18n({
  locale: lang,
  messages: {
    zh: zh,
    en: en
  }
})

export default i18n
